module.exports = __webpack_public_path__ + "static/img/wallpaper-mb2.d90f92a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb2.jpg
// module id = XZER
// module chunks = 1